document.addEventListener('DOMContentLoaded', function () {
  let scrollTop = 0;

  // 1. Handle AJAX Add to Cart from product grid
  document.querySelectorAll('.ajax-add-to-cart').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      const isPreorder = this.dataset.isPreorder === 'true';
      const preorderMessage = this.dataset.preorderMessage;
      this.classList.add('btn--loading');

      const cartBody = { id: variantId, quantity: 1 };
      if (isPreorder && preorderMessage) {
        cartBody.properties = {
          '_preOrder': 'true',
          '_preOrderMessage': preorderMessage,
          'Pre-order Message': preorderMessage
        };
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartBody)
      })
        .then(res => {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(() => {
          // Rebuild cart via native theme event
          document.dispatchEvent(new CustomEvent('cart:build'));

          // Trigger cart drawer open
          const cartBtn = document.querySelector('.js-drawer-open-cart');
          if (cartBtn) cartBtn.click();
        })
        .catch(err => {
          console.error('❌ Failed to add to cart:', err);
        })
        .finally(() => {
          this.classList.remove('btn--loading');
        });
    });
  });

  // 2. Fix scroll issue on drawer open/close
  // document.addEventListener('cart:build', function () {
  //   scrollTop = window.scrollY;
  //   document.documentElement.classList.add('lock-scroll');
  //   document.body.style.top = `-${scrollTop}px`;
  //   document.body.style.position = 'fixed';
  //   document.body.style.width = '100%';
  // });

  const closeButton = document.querySelector('.drawer__close-button.js-drawer-close');
  if (closeButton) {
    closeButton.addEventListener('click', function (e) {
      e.preventDefault();
      document.documentElement.classList.remove('lock-scroll');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo({ top: scrollTop, behavior: 'auto' });
    });
  }

  // 3. Store location selection in availability drawer
  document.addEventListener('click', function (e) {
    const item = e.target.closest('.store-availability-location-item');
    if (!item) return;

    const name = item.dataset.locationName;
    const pickupTime = item.dataset.pickupTime;
    const available = item.dataset.available === 'true';

    // Update inline display inside data-store-availability-holder
    const holder = document.querySelector('[data-store-availability-holder]');
    if (!holder) return;

    const nameEl = holder.querySelector('[data-inline-name]');
    const timeEl = holder.querySelector('[data-inline-time]');
    const iconEl = holder.querySelector('[data-inline-icon]');

    if (nameEl) {
      if (available) {
        nameEl.innerHTML = 'Pickup available at <strong>' + name + '</strong>';
      } else {
        nameEl.innerHTML = 'Pickup currently unavailable at <strong>' + name + '</strong>';
      }
    }

    if (timeEl) {
      timeEl.textContent = available ? pickupTime : '';
      timeEl.style.display = available ? '' : 'none';
    }

    if (iconEl) {
      iconEl.innerHTML = available
        ? '<span class="sa-dot sa-dot--available"></span>'
        : '<span class="sa-dot sa-dot--unavailable"></span>';
    }

    // Mark selected item in drawer
    document.querySelectorAll('.store-availability-location-item').forEach(function (el) {
      el.classList.remove('is-selected');
    });
    item.classList.add('is-selected');

    // Close the drawer
    const closeBtn = document.querySelector('#StoreAvailabilityDrawer .js-drawer-close');
    if (closeBtn) closeBtn.click();
  });

  // Keyboard support for location items (Enter / Space)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const item = e.target.closest('.store-availability-location-item');
    if (!item) return;
    e.preventDefault();
    item.click();
  });
});
